
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import MasterLayout from '@/components/MasterLayout.vue';
import PostHeader from '@/components/NonLoggedInComponents/PostHeader.vue';
import PostIntro from '@/components/NonLoggedInComponents/PostIntro.vue';
import PostInfoHeader from '@/components/NonLoggedInComponents/PostInfoHeader.vue';
import PostInfoImg from '@/components/NonLoggedInComponents/PostInfoImg.vue';
import PostContact from '@/components/NonLoggedInComponents/PostContact.vue';
import PostSpacer from '@/components/NonLoggedInComponents/PostSpacer.vue';
import PostCard from '@/components/NonLoggedInComponents/PostCard.vue';
import PostDivider from '@/components/NonLoggedInComponents/PostDivider.vue';
import PostInfoImg2Col from '@/components/NonLoggedInComponents/PostInfoImg2Col.vue';
import J1LGetStarted from '@/components/NonLoggedInComponents/J1LGetStarted.vue';

@Component({
  components: {
    MasterLayout,
    PostHeader,
    PostIntro,
    PostInfoHeader,
    PostInfoImg,
    PostInfoImg2Col,
    PostContact,
    PostCard,
    PostDivider,
    PostSpacer,
    J1LGetStarted
  }
})
export default class BathBodyProducts extends Vue {
  $refs!: {
    DefaultActions: HTMLFormElement;
  };
  metaInfo(): any {
    return {
      meta: [
        {
          name: 'description',
          content:
            'Just 1 Label has every solution you need for custom, digitally printed bath and body labels. View details, register online and start ordering labels today!'
        }
      ],
      title: 'Custom Bath &amp; Body Labels, Digital Bath and Body Labels'
    };
  }
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  /* Computed */
  /* Async Functions */
  /* Utility Functions */
  /* Loaders */
  /* Mounted */
  /* Created */
  /* Emmited Functions */
}
